module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon9.129d4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon9.png
// module id = vOoY
// module chunks = 0